const publicUrl = process.env.PUBLIC_URL || "";

const projects = [
  {
    title: "WhatsaStore Web App",
    description:
      "Gives small businesses one place to track leads, orders and customer follow-ups on WhatsApp.",
    tags: ["Lead tracking", "Order follow-up", "Customer retention"],
    image: `${publicUrl}/projects/whatsastore-preview.png`,
    imageAlt: "WhatsaStore application screenshot",
    tone: "green",
    links: {
      demo: "https://whatsastore.online/",
      github: null
    }
  },
  {
    title: "WhatsaStore Helper",
    description:
      "Helps sellers move faster by syncing contacts and streamlining WhatsApp sales follow-up.",
    tags: ["Workflow speed", "Contact sync", "Sales support"],
    image: `${publicUrl}/projects/whatsastore-helper-preview.png`,
    imageAlt: "WhatsaStore Helper Chrome extension screenshot",
    tone: "green",
    links: {
      demo: "https://chromewebstore.google.com/detail/whatsastore-helper/nnpbmffehjadfimgaolcegiekfekngoi?hl=fr&utm_source=ext_sidebar",
      github: null,
      demoLabel: "Chrome Web Store"
    }
  },
  {
    title: "Sketchstash",
    description:
      "Keeps commands, notes and technical snippets easy to save, find and reuse later.",
    tags: ["Knowledge capture", "Fast recall", "Developer notes"],
    image: `${publicUrl}/projects/sketchstash-preview.png`,
    imageAlt: "Sketchstash application screenshot",
    tone: "blue",
    links: {
      demo: "https://sketchstash.online/",
      github: "https://github.com/hamza-topo/boxnot"
    }
  },
  {
    title: "NawarGlam",
    description:
      "Improves product discovery and makes WhatsApp-first ordering feel simple for shoppers.",
    tags: ["Product discovery", "WhatsApp ordering", "Shoppers"],
    image: `${publicUrl}/projects/nawarglam-preview.png`,
    imageAlt: "NawarGlam website screenshot",
    tone: "pink",
    links: {
      demo: "https://nawarglam.com/",
      github: null
    }
  },
  {
    title: "PetMingle",
    description:
      "A concept for pet discovery, matching and adoption-style browsing flows.",
    tags: ["Discovery", "Matching", "Coming soon"],
    status: "Coming soon",
    image: null,
    imageAlt: "PetMingle coming soon preview",
    tone: "amber",
    links: {
      demo: null,
      github: null
    }
  }
];

export default projects;
